import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconMuted = function IconMuted(_ref) {
  var isMute = _ref.isMute;
  return (
    /*#__PURE__*/
    /* eslint-disable-next-line react/forbid-elements */
    _jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 -35 416.245 416",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M65 250.477l147 95.21V.122L65 95.332zm0 0"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0 99.906h49v146H0zm0 0"
      }), isMute && /*#__PURE__*/_jsx("path", {
        d: "M413.898 113.504c-3.12-3.121-8.187-3.121-11.312 0l-48.082 48.086-48.082-48.086a8.003 8.003 0 0 0-13.422 3.57 7.996 7.996 0 0 0 2.11 7.746l48.081 48.086-48.082 48.082a8.002 8.002 0 0 0 11.313 11.316l48.082-48.081 48.086 48.082c3.125 3.125 8.187 3.125 11.312 0s3.121-8.192-.004-11.317l-48.078-48.082 48.078-48.082a8 8 0 0 0 0-11.32zm0 0"
      })]
    })
  );
};